let isMobileToggleBound = false;

function teamGroupToggle() {
    const isMobile = $(window).width() < 1024;

    if (isMobile && !isMobileToggleBound) {
        $('.team_group .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`<button type="button" aria-expanded="false">${content}</button>`)
            $(this).siblings().attr('aria-hidden', 'true');
        });
        $('body').on('click.mobileToggle', '.team_group .wp-block-heading button', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).attr('aria-expanded', $(this).parent().hasClass('open') ? 'true' : 'false');
            $(this).parent().siblings().attr('aria-hidden', $(this).parent().hasClass('open') ? 'false' : 'true');
            $(this).parent().siblings().slideToggle(150, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });
        isMobileToggleBound = true;
    } else if (!isMobile && isMobileToggleBound) {
        $('.team_group .wp-block-heading').each(function (){
            const content = $(this).text();
            $(this).text('').append(`${content}`)
            $(this).siblings().removeAttr('aria-hidden');
        });
        $('body').off('click.mobileToggle');
        isMobileToggleBound = false;
    }
}

$(document).ready(function () {
    teamGroupToggle();
    $(window).on('resize', teamGroupToggle);

    $('body').on('click', '.engineer_card__show_properties a:not(.open)', function (e){
        e.preventDefault();
        let that = $(this);
        $(this).addClass('open').html('Show Less<i class="icon icon-link-arrow"></i>');
        $(this).parent().parent().find('.engineer_card__properties').slideDown(150, function (){
            console.log(that)
            that.parent().siblings('.engineer_card__properties').find('.engineer_card__properties-list li:first-child a').focus();
        });
    })

    $('body').on('click', '.engineer_card__show_properties a.open', function (e){
        e.preventDefault();
        $(this).removeClass('open').html('Show Properties<i class="icon icon-link-arrow"></i>');
        $(this).parent().parent().find('.engineer_card__properties').slideUp(150);
    })
});


